(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.rules = svs.numbergames.rules || {};
svs.numbergames.rules.utils = svs.numbergames.rules.utils || {};
svs.numbergames.rules.utils.keno_winplan = svs.numbergames.rules.utils.keno_winplan || {};
svs.numbergames.rules.utils.lotto = svs.numbergames.rules.utils.lotto || {};
svs.numbergames.rules.utils.vikinglotto = svs.numbergames.rules.utils.vikinglotto || {};
svs.numbergames.rules.utils.joker = svs.numbergames.rules.utils.joker || {};
svs.numbergames.rules.logger = new svs.core.log.Logger('numbergames:rules');

 })(window);